var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcr-user-menu"},[_c('router-link',{attrs:{"to":{
      name: _vm.RouterName.userProfile,
    }}},[_c('vtx-user-profile',{attrs:{"full-name":_vm.getFullName(_vm.currentUser),"img-src":_vm.currentUser.avatar ? _vm.currentUser.avatar : _vm.placeholder}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }